import React, { useCallback } from "react";
import { Facet } from "@linkfluence/models/facet";
import Subtitle from "@radarly/components/cards/card/subtitle";
import { useCurrentProject } from "@radarly/core/project/use-cases";
import { ClassificationCard } from "@radarly/models/cards/model";
import { createClauseFromInnerClause } from "@radarly/models/clause/creator";
import { getDateFromClause } from "@radarly/models/clause/getter";
import { getPostSortFromMetric } from "@radarly/models/posts";
import Date from "@radarly/shared/cards/subtitle/date";
import Metric from "@radarly/shared/cards/subtitle/metric";
import Tile from "@radarly/shared/cards/tile";
import Widget from "@radarly/shared/widgets/classification";
import { useFragments } from "../fragment";
import { useGenerateCSV } from "../hooks/useGenerateCSV";
import { CardProps } from "../model";

const RadarlyClassificationCard = ({
  card,
  clause,
  from,
  to,
  height,
  openPostsPanel,
  timezone,
  forceReload,
  nowDate,
}: CardProps<ClassificationCard>) => {
  const project = useCurrentProject();
  const fragments = useFragments(
    [card.fragments[0], card.fragments[1]],
    clause,
    from,
    to,
    timezone
  );
  const fragment = fragments[0];
  const evolutionFragment = fragments[1];
  const dataviz = card.dataviz;
  const title = card.title;
  const { onGenerateCSV } = useGenerateCSV(title, fragments[0], fragments[1]);

  const onClickItem = useCallback(
    (id: string | number) => {
      const { from, to } = getDateFromClause(fragment.request.query);
      openPostsPanel({
        clause: fragment.request.query,
        period: {
          from: from,
          to: to,
        },
        title,
        focusClause: createClauseFromInnerClause({
          [Facet.ContentClassification]: ["" + id],
        }),
        sortBy: getPostSortFromMetric(
          fragment.request.aggs.contentClassification.metrics[0]
        ),
        timezone,
      });
    },
    [
      fragment.request.aggs.contentClassification.metrics,
      fragment.request.query,
      openPostsPanel,
      timezone,
      title,
    ]
  );
  return (
    <Tile
      title={title}
      height={height}
      subtitle={
        <Subtitle
          meta={[
            <Date fragment={fragment} timezone={timezone} nowDate={nowDate} />,
            <Metric
              metric={fragment.request.aggs.contentClassification.metrics[0]}
            />,
          ]}
        />
      }
      clause={fragment.request.query}
      onGenerateCSV={onGenerateCSV}
      isPNG
    >
      <Widget
        fragment={fragment}
        evolutionFragment={evolutionFragment}
        project={project.id}
        dataviz={dataviz}
        onClickItem={openPostsPanel ? onClickItem : null}
        forceReload={forceReload}
      />
    </Tile>
  );
};

export default RadarlyClassificationCard;
